import timerBox from "./assets/timer-box.png"
import clock from "./assets/clock.png"
import { Button } from "./button"
import heroBorderBottom from "./assets/hero-border-bottom.svg"

interface Props {
  formattedCountdown: string
  onClick: () => void
}

export function Hero({ formattedCountdown, onClick }: Props) {
  return (
    <div className="bg-cover bg-center bg-no-repeat w-full bg-black">
      <div className="flex items-center justify-between">
        <div>
          <div
            className="w-[165px] h-[123px] bg-center bg-no-repeat relative bg-[length:100%_100%] text-white"
            style={{ backgroundImage: `url(${timerBox})` }}
          >
            <div className="absolute font-quirk uppercase text-[18px] leading-[28px] tracking-[0.4px] rotate-[15deg] bottom-[31px] left-[38px]">
              <span className="inline-block w-[42px]">
                {formattedCountdown}
              </span>{" "}
              left
            </div>
          </div>
          <h1 className="font-quirk text-white ml-8 text-[32px] leading-[40px] -rotate-[5deg]">
            Grab
            <br />
            <span className="whitespace-nowrap">the offer</span>
          </h1>
        </div>
        <div>
          <img src={clock} className="w-full h-auto" />
        </div>
      </div>
      <div className="relative pt-6">
        <Button
          className="w-[182px] rotate-[6deg] absolute right-10 bottom-7"
          theme="white"
          onClick={onClick}
        >
          Get my plan
        </Button>
        <img src={heroBorderBottom} className="h-[99px] w-full" />
      </div>
    </div>
  )
}
